import { useBroadcastUpdate, usePresentatorId } from "@solidwhite/multiuser";
import { useSpring } from "@react-spring/three";

const CarrierSequenceSynchrnoizer = ({ sequence }) => {
  const presId = usePresentatorId();

  const [spring, api] = useSpring(() => ({
    sequencePos: 0,
    onChange: ({ value }) => {
      sequence.position = value.sequencePos;
      console.log(sequence.position);
    },
    config: {
      tension: 280,
      friction: 30,
    },
  }));

  useBroadcastUpdate(presId, "car_seq", (v) => {
    api.start({ sequencePos: v });
  });

  return null;
};

export default CarrierSequenceSynchrnoizer;
